class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(
        this.dataset.index,
        0,
        null,
        this.dataset.quantityVariantId,
        this.dataset.key,
        this.dataset.imbox,
        this.dataset.imboxKey,
        this.dataset.imboxQuantity,
        this.dataset.previousValue,
      );
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartImboxCheckbox extends HTMLElement {
  constructor() {
    super();

    const key = this.dataset.key;
    const line = this.dataset.index;
    const variantId = this.dataset.quantityVariantId;
    const imboxKey = this.dataset.imboxKey;
    const imboxQuantity = this.dataset.imboxQuantity;
    const productQuantity = this.dataset.productQuantity;
    const imboxId = this.dataset.imboxId;
    const checkbox = this.querySelector('input[type="checkbox"]');
    const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');

    if (cartItems) {
      checkbox.addEventListener('change', async (event) => {
        event.preventDefault();
        const hasImbox = imboxQuantity !== '';
        const newImboxQuantity = !hasImbox
          ? productQuantity
          : event.target.checked
            ? parseInt(imboxQuantity) + parseInt(productQuantity)
            : parseInt(imboxQuantity) - parseInt(productQuantity);

        cartItems.enableLoading(line);
        await this.updateCartQuantity(imboxQuantity > 0 ? imboxKey : imboxId, newImboxQuantity, !hasImbox);
        await this.updateShoeProperties(key, !event.target.checked, productQuantity);
        await cartItems.fetchCartUpdate({
          route: routes.cart_update_url,
          updates: {},
          name: 'imboxCheckbox',
          line,
          variantId,
        });
      });
    }
  }

  async updateCartQuantity(productId, quantity, addToCart) {
    if (addToCart) {
      let formData = {
        items: [
          {
            id: productId,
            quantity: quantity,
          },
        ],
      };
      await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });
      return;
    } else {
      await fetch('/cart/change.js', {
        method: 'POST',
        body: JSON.stringify({ id: productId, quantity: quantity }),
        headers: {
          'Content-Type': 'application/json',
        },
      });

      return;
    }
  }

  async updateShoeProperties(shoeId, removeImbox, productQuantity) {
    let properties = {};
    if (!removeImbox) {
      properties['_imbox'] = 'True';
    } else {
      properties['_imbox'] = '';
    }

    await fetch('/cart/change.js', {
      method: 'POST',
      body: JSON.stringify({ id: shoeId, properties: properties, quantity: productQuantity }),
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return;
  }
}

customElements.define('cart-imbox-checkbox', CartImboxCheckbox);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');
    this.imboxId = this.dataset.imboxId;

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));

    const imboxBoxes = document.querySelectorAll('.imbox-drawer-button');

    if (imboxBoxes) {
      imboxBoxes.forEach((box) => {
        box.addEventListener('click', (event) => {
          const description = document.querySelector('[data-paragraph="' + box.dataset.parentid + '"]');
          if (description.style.display === 'block') {
            description.style.display = 'none';
          } else {
            description.style.display = 'block';
          }
        });
      });
    }
  }

  cartChangeUnsubscriber = undefined;

  connectedCallback() {
    this.checkValidImboxQuantity();
    this.cartChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartChangeUnsubscriber) {
      this.cartChangeUnsubscriber();
    }
  }

  checkValidImboxQuantity() {
    // // fetch cart items
    fetch('/cart.js', { method: 'GET' })
      .then((res) => res.json())
      .then((response) => {
        const cart = response;
        const imboxItems = cart.items.filter((t) => t.id.toString() === this.imboxId);

        var count = 0;
        cart.items
          .filter((t) => t.properties._imbox === 'True')
          .forEach((t) => {
            count += t.quantity;
          });

        var imboxCount = 0;
        imboxItems.forEach((t) => {
          imboxCount += t.quantity;
        });

        if (imboxCount === count) {
          return;
        }

        if (imboxCount === 0) {
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              items: [
                {
                  id: this.imboxId,
                  quantity: count,
                },
              ],
            }),
          }).then((response) => {
            if (response.status === 200) {
              location.reload();
            }
          });
        } else {
          fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              updates: {
                [imboxItems[0].id]: count,
              },
            }),
          }).then((response) => {
            if (response.status === 200) {
              location.reload();
            }
          });
        }
      })
      .catch((error) => console.error('Error:', error));
  }

  onChange(event) {
    if (event.target.id.startsWith('Imbox-')) {
      event.preventDefault();
      return;
    }
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute('name'),
      event.target.dataset.quantityVariantId,
      event.target.dataset.key,
      event.target.dataset.imbox,
      event.target.dataset.imboxKey,
      event.target.dataset.imboxQuantity,
      event.target.dataset.previousValue,
    );
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId, key, imboxEnabled, imboxKey, imboxQuantity, previousValue) {
    this.enableLoading(line);

    // check if item was added or removed
    let imbox = {};
    if (imboxEnabled === 'True' && imboxKey && imboxQuantity) {
      const previousValueInt = parseInt(previousValue);
      const quantityInt = parseInt(quantity);
      const quantityDiff = quantityInt - previousValueInt;
      const isAdding = quantityDiff > 0;

      if (isAdding) {
        imbox = { [imboxKey]: parseInt(imboxQuantity) + quantityDiff };
      } else {
        imbox = { [imboxKey]: Math.max(parseInt(imboxQuantity) + quantityDiff, 0) };
      }
    }

    const updates = { [key]: parseInt(quantity), ...imbox };
    this.fetchCartUpdate({ route: routes.cart_update_url, updates, name, line, variantId });
  }

  fetchCartUpdate({ route, updates, name, line, variantId }) {
    const body = JSON.stringify({
      updates: updates,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(route, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          if (quantityElement) {
            quantityElement.value = quantityElement.getAttribute('value');
          }
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          // we update cart drawer with every element except for the fresh relevance section
          if (section.id === 'CartDrawer') {
            let wrapper = document.createElement('div');
            let newInnerHtml = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            wrapper.innerHTML = newInnerHtml;

            const freshRelevanceIndexInWrapper = Array.from(wrapper.children).findIndex(
              (el) => el.id === 'cart-fresh-relevance',
            );
            const childrenBeforeFreshRelevance = Array.from(wrapper.children).slice(0, freshRelevanceIndexInWrapper);
            const childrenAfterFreshRelevance = Array.from(wrapper.children).slice(freshRelevanceIndexInWrapper + 1);

            // delete all children of elementToReplace without id cart-fresh-relevance
            let childrenToDelete = Array.from(elementToReplace.children).filter(
              (el) => el.id !== 'cart-fresh-relevance',
            );
            childrenToDelete.forEach((el) => {
              elementToReplace.removeChild(el);
            });

            // add new before
            childrenBeforeFreshRelevance.reverse().forEach((el) => {
              elementToReplace.insertBefore(el, elementToReplace.firstChild);
            });

            // add new after
            childrenAfterFreshRelevance.forEach((el) => {
              elementToReplace.appendChild(el);
            });

            const imboxBoxes = elementToReplace.querySelectorAll('.imbox-drawer-button');

            imboxBoxes.forEach((box) => {
              box.addEventListener('click', (event) => {
                const description = elementToReplace.querySelector('[data-paragraph="' + box.dataset.parentid + '"]');
                if (description.style.display === 'block') {
                  description.style.display = 'none';
                } else {
                  description.style.display = 'block';
                }
              });
            });
          } else {
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector,
            );
          }
        });

        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (
          quantityElement &&
          items.length === parsedState.items.length &&
          updatedValue !== parseInt(quantityElement.value)
        ) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (name !== null && lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch((error) => {
        console.error(error);
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER),
        );
      }
    },
  );
}
